import { useKioskDeviceLocation } from '@/hooks/useKioskDeviceLocation';
import { usePickupTime } from '@/hooks/usePickupTime';
import { deviceLocationType } from '@/types/data';
import { useWatch } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

const DAY_LABELS: Record<string, string> = {
  pick_up_table_days_1: 'Mon',
  pick_up_table_days_2: 'Tue',
  pick_up_table_days_3: 'Wed',
  pick_up_table_days_4: 'Thu',
  pick_up_table_days_5: 'Fri',
  pick_up_table_days_6: 'Sat',
  pick_up_table_days_7: 'Sun'
};

export default function GeneralPickUpNotice() {
  const intl = useIntl();
  const { dayOfTheWeek, pickupDateTwo, pickupTimeTwo, earlyPickupWeekday, latePickupWeekday, earlyPickupDate, earlyPickupTime } =
    usePickupTime();
  const [deviceLocation] = useKioskDeviceLocation();
  const pickupLocation: deviceLocationType = useWatch({ name: 'pickup_location' }) ?? deviceLocation;

  return (
    <>
      <div>
        <span className="text-[16px] font-semibold bg-[#fff2f2]">
          <FormattedMessage id="pick_up_notice_sub_title_1" defaultMessage="[When you pick-up]" />
        </span>
        <ul className="flex flex-col gap-1">
          <li className="text-[13px] list-none">
            <FormattedMessage
              id="pick_up_notice_sub_title_1_list_1"
              defaultMessage="· Pickups are only available during store opening hours, and please see below for specific pickup hours."
            />
          </li>
          <li className="text-[13px] list-none">
            <FormattedMessage
              id="pick_up_notice_sub_title_1_list_2"
              defaultMessage="· When you pickup photocards, show the staff your payment receipt and the invoice that was emailed to you."
            />
          </li>
        </ul>
      </div>
      <div>
        <span className="text-[16px] font-semibold mt-4 bg-[#fff2f2]">
          <FormattedMessage id="pick_up_notice_sub_title_2" defaultMessage="[Pick-up schedule]" />
        </span>
        <div className="text-[13px] text-[#262626] mt-1">
          <FormattedMessage
            id="pick_up_notice_sub_desc_1"
            values={{
              openHour: pickupLocation === 'hongdae' ? '11:00' : '10:30',
              closeHour: pickupLocation === 'hongdae' ? '9:00' : '10:30'
            }}
            defaultMessage="Opening hours: Everyday, {openHour} AM to {closeHour} PM"
          />
        </div>
        <div className="border border-[#ededed] rounded-[10px] overflow-hidden mt-2">
          <table border={1} className="w-full rounded text-[13px] font-semibold text-center [border-style:hidden]">
            <thead>
              <tr className="bg-[#fafafa] h-[50px] font-semibold">
                <td className="w-[120px] font-semibold" />
                <td>
                  <FormattedMessage id="orders_before_4_hour" defaultMessage="Orders before 4:00 PM" />
                </td>
                <td>
                  <FormattedMessage id="orders_after_4_hour" defaultMessage="Orders after 4:00 PM" />
                </td>
              </tr>
            </thead>
            <tr className="h-[50px] font-medium">
              <td className="w-[120px] font-semibold">
                <FormattedMessage
                  id={`pick_up_table_days_${dayOfTheWeek}`}
                  defaultMessage={DAY_LABELS[`pick_up_table_days_${dayOfTheWeek}`] ?? ''}
                />
              </td>
              <td>
                <FormattedMessage
                  id="pick_up_table_case_text_date"
                  values={{
                    date: `${earlyPickupDate} ${earlyPickupTime}`,
                    day: `(${intl.formatMessage({
                      id: `pick_up_table_days_${earlyPickupWeekday}`,
                      defaultMessage: DAY_LABELS[`pick_up_table_days_${earlyPickupWeekday}`] ?? ''
                    })})`
                  }}
                  defaultMessage="{date} PM{day} ~ following 3 days"
                />
              </td>
              <td>
                <FormattedMessage
                  id="pick_up_table_case_text_date"
                  values={{
                    date: `${pickupDateTwo} ${pickupTimeTwo}`,
                    day: `(${intl.formatMessage({
                      id: `pick_up_table_days_${latePickupWeekday}`,
                      defaultMessage: DAY_LABELS[`pick_up_table_days_${latePickupWeekday}`] ?? ''
                    })})`
                  }}
                  defaultMessage="{date} PM{day} ~ following 3 days"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </>
  );
}
